<template>
    <div class="figure-container">
        <template v-if="images.length">
            <div class="theme-image">
                <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                    <van-swipe-item v-for="image in images" :key="image.id">
                        <img :src="image.coverIcon" @click="handleSwiperClick(image)">
                    </van-swipe-item>
                </van-swipe>
                
            </div>
            <div class="figure-icon">
                <div
                    class="figure-icon-item"
                    v-for="(item, index) in classifyList"
                    :key="item.name"
                    @click="figureClick(index)"
                    :class="[active === index ? 'active' : '']"
                >
                    <img v-if="active === index" class="img" :src="item.activeUrl">
                    <img v-else class="img" :src="item.url">
                    <div class="figure-icon-text">{{item.name}}<i v-if="item.point" class="point"></i></div>
                    <div class="line" :style="{background: item.activeColor}"></div>
                </div>
            </div>
            <div class="figure-content">
                <div class="tab-content" v-if="tabsList.length">
                    <!-- 新闻资讯 -->
                    <div class="news-section" v-for="news in tabsList" :key="news.id" @click="toNews(news)">
                        <div class="news-img">
                            <img :src="news.targetCoverIcon">
                        </div>
                        <div class="news-content">
                            <div class="news-title">{{news.targetTitle}}</div>
                            <div class="news-time">{{news.targetCreateTime | formatDate(1)}}</div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="empty-container">
                        <div class="empty-content">
                            <img class="img" src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/mini/portal/empty.png">
                            <p class="text">暂无数据</p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="figure-loading">
                <van-loading size="40px" vertical text-size="12px">加载中...</van-loading>
            </div>
        </template>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

const preId = localStorage.getItem('__JRH5_UUID__')
let uuid
if (!preId) {
    uuid = uuidv4().replace(/-/g, '')
    localStorage.setItem('__JRH5_UUID__', uuid)
} else {
    uuid = preId
}

const requestParams = {
    appId: "d8c0f65aadff4b43a86c0b8ec2165a82",
    exhibitionId: "70bb20a25a564ed6b99eef1920678f79",
    languageType: "cn",
    subjectType: "VISITOR",
    terminal: "app",
}
const env = process.env.NODE_ENV
const devToken = 'HJBFYlwJI3DEyD1gFtHGtw3aSdRWkEvijlaHDe7eVSVukzJL8sy9xejRaP1eAgzdUPhxy05wkLVP+JF4WUqsvJKE+QZlrh052HQ7o8yoGRa0j6OqgNcYlEt9Fr3EKIdcfXUGUXy3FW/D8+TNCbSzFoNXpJstpnN69HdpVeAABRhkv567WyZWtdMGiqFrFuRF8+3RxcMSMdQMf9/EAb83UtlXxErthx6d9Ukc3CxC/lmcGahZuCMcrRNZMhtBu91KePcuEcA4NG4/cAThXb2CqO7QHHYYnsZj1S2qJvtNNG7e8bxK3l0yvQAeuW1oUCGpHA0Mt6iO51rAwjsAGto1C8j4itfXu/gRrBeWiHj1PnLEo5nFmTfafAw4NqyujS6g+lvQTid31xz67s5nPYaC91ZZjK14/NYKqAlb2BMxwb+WP9bj2o3h2AIXYVwTKkCY'
const proToken = 'GW1yXNm1dXScd12i7KwdZz8RUNN9P33yDDjUW4vlMt3GqTTtK0xlBOZ/bJUKrMMzDkjnW7pPTlaOLZFTHXpv2nIWw2JSaMj2KMU2C4+nf3fXMCvVzwc8sENGeDOIUG+48/lzo80KxYaPNqn7kEkK/3Rc8EAaW5nY1Lvk9r276ZDkm8XGjfVQCWDv7k1+KYYX7h18E1SncYIPukUmWlVAsHzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ='
const token = env === 'production' ? proToken : devToken

export default {
    data() {
        return {
            active: 0,
            showPopover: false,
            images: [],
            bannerMap: {},
            actions: [
                { text: '全部', index: 0},
                { text: '资讯', index: 1 },
                { text: '视频', index: 2 },
                { text: '直播', index: 3 },
            ],
            classifyList: [
                {
                    name: '数字战略',
                    code: 'FIGURE_STRATEGY',
                    url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_1.png',
                    activeUrl: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_1_active.png',
                    activeColor: '#FF7696',
                    point: false,
                    list: [],
                    tabNews: [], // 新闻详情列表
                    liveList: [] // 直播详情列表
                },
                {
                    name: '数字科技',
                    code: 'FIGURE_TECHNOLOGY',
                    url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_4.png',
                    activeUrl: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_4_active.png',
                    activeColor: '#4F97FC',
                    point: false,
                    list: []
                },
                {
                    name: '数字生态',
                    code: 'FIGURE_ECOLOGY',
                    url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_3.png',
                    activeUrl: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_3_active.png',
                    activeColor: '#44D7B6',
                    point: false,
                    list: []
                },
                {
                    name: '数字体验',
                    code: 'FIGURE_EXPERIENCE',
                    url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_5.png',
                    activeUrl: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_5_active.png',
                    activeColor: '#38DBEF',
                    point: false,
                    list: []
                },
                {
                    name: '数字人才',
                    code: 'FIGURE_TALENTS',
                    url: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_2.png',
                    activeUrl: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/figure/icon_2_active.png',
                    activeColor: '#FFAE42',
                    point: false,
                    list: []
                },
            ]
        }
    },
    computed: {
        tabsList() {
            return this.classifyList[this.active].list.filter(item => item.url)
        }
    },
    mounted() {
        this.initParams()
        this.getFigures()

        const id = this.$route.params.id
        this.active = Math.max(0, Math.min(Number(id - 1), 4))
    },
    methods: {
        initParams() {
            const query = this.$route.query
            requestParams.appId = query.appId ? query.appId : requestParams.appId,
            requestParams.exhibitionId = query.exhibitionId ? query.exhibitionId : requestParams.exhibitionId,
            requestParams.languageType = query.languageType || 'cn',
            requestParams.subjectType = query.showType || 'VISITOR',
            this.$store.commit('changeToken', token)
        },
        async getFigures() {
            const params = {
                ...requestParams,
                sourceType: 0,
                userId: uuid
            }
            const result = await this.$http.getFigures(params)
            const { code, data } = result
            if (code === 1000) {
                const bannerMap = data.bannerMap
                const bannerStateMap = data.bannerStateMap || {}

                this.images = bannerMap['FIGURE_BANNER'] || []
                this.classifyList = this.classifyList.map(item => {
                    item.list = bannerMap[item.code]
                    item.point = bannerStateMap[item.code]
                    return item
                })
                this.bannerMap = bannerMap // 保存初始值
            }
        },
        figureClick(index) {
            this.active = index

            // 已读上报
            const key = this.classifyList[this.active].code
            this.classifyList[this.active].point = false
            this.handleRead(key)
        },
        async handleRead(showType) {
            const params = {
                userId: uuid,
                sourceType: 0,
                showType
            }
            const result = await this.$http.readBannerNews(params)
            if (result.code === 1000) {
                // console.log('===已读上报成功===')
            }
        },
        padStart(value) {
            return String(value).padStart(2, '0')
        },
        removeTAG(str) {
            return str.replace(/<[^>]+>/g, "").replace(/\&nbsp;/g, "");
        },
        toNews(news) {
            // const desc = this.removeTAG(news.targetContent)
            const params = {
                path: 'newsDetail',
                id: news.url, // 新闻id
                name: news.targetTitle,
                icon: news.targetShareImage || news.targetCoverIcon
            }
            this.hrefAppFn(params)
        },
        hrefAppFn(params) {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   // 判断是否是 android终端
            let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

            // 微信浏览器
            if (this.isWeiXinFn()) {
                const token = this.$store.state.user.token
                const env = process.env.NODE_ENV
                const host = env === 'production' ? 'izt.eastfair.cn' : 'http://10.20.16.98:9002'
                if (params.path === 'newsDetail') {
                    window.location.href = `https://${host}/h5/AudArticle.html?exhibitionId=${requestParams.exhibitionId}&Token=${token}&id=${params.id}&languageType=${requestParams.languageType}&theme=jinrong&bgcolor=E60012`
                } else if (params.path === 'liveDetail') {
                    window.location.href = `https://${host}/h5-web/#/shareLive?languageType=${requestParams.languageType}&token=${token}&liveId=${params.id}&showType=${requestParams.subjectType}&theme=jinrong&bgcolor=E60012`
                }
                
                return
            }

            // app点击
            if (isAndroid) {
                window.messageHandlers.hrefApp(JSON.stringify(params))
            } else if (isIOS) {
                window.webkit && window.webkit.messageHandlers.hrefApp.postMessage(JSON.stringify(params))
            }

        },
        isWeiXinFn() {
            const ua = navigator.userAgent.toLowerCase()
            const isWXWork = ua.match(/wxwork/i) == 'wxwork'
            const isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger'
            return isWeixin
        },
        handleSwiperClick(item) {
            const urlType = item.urlType

            switch(urlType) {
                case 'INTERH5':
                    window.open(item.url, '_blank')
                    break
                case 'NEWS':
                    this.hrefAppFn({
                        path: 'newsDetail',
                        id: item.url
                    })
                    break
                case 'liveRoom': 
                    this.hrefAppFn({
                        path: 'liveDetail',
                        id: item.url
                    })
                    break
                default:
                    break
            }
        }
    }
}
</script>

<style lang="less" scoped>
.figure-container {
    width: 100%;
    max-width: 450px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #fbfbfb;
    margin: 0 auto;
    .theme-image {
        height: 160px;
        position: relative;
        padding: 12px 15px 0;
        background: #fbfbfb;
        .my-swipe {
            height: 160px;
            border-radius: 4px;
            overflow: hidden;
        }
        img {
            width: 100%;
            height: 100%;
        }
        .text {
            position: absolute;
            bottom: 18px;
            right: 18px;
            color: #ffffff;
            font-size: 18px;
        }
    }
    .figure-icon {
        display: flex;
        justify-content: space-between;
        padding: 12px 15px;
        background: #fbfbfb;
        .figure-icon-item {
            width: 54px;
            border-radius: 4px;
            position: relative;
            font-size: 0;
            .img {
                width: 100%;
                // height: 100%;
                height: 54px;
            }
            .figure-icon-text {
                font-size: 12px;
                text-align: center;
                margin-top: 8px;
                color: rgba(0, 0, 0, 0.45);
                position: relative;
                .point {
                    width: 5px;
                    height: 5px;
                    background: red;
                    border-radius: 50%;
                    position: absolute;
                    top: 0px;
                    right: -3px;
                }
            }

            &.active {
                .figure-icon-text {
                    color: rgba(0, 0, 0, 0.85);
                    font-weight: bold;
                }
                .line {
                    width: 50%;
                    margin: 0 auto;
                    height: 2px;
                    margin-top: 4px;
                }
            }

        }
    }
    .figure-content {
        position: relative;
        /deep/ .van-tab {
            flex: none !important;
            padding: 18px;
        }
        /deep/ .van-hairline--top-bottom::after {
            border-width: 0;
        }
        .filter-section {
            font-size: 13px;
            color: rgba(0, 0, 0, 0.65);
            background: #ffffff;
            padding: 6px 15px;
            text-align: right;
            .filter-text {
                display: flex;
                align-items: center;
            }
            .iconfont {
                font-size: 13px;
                margin-right: 4px;
            }
        }
    }
    .tab-content {
        padding: 0 12px 15px;
        .video-section {
            width: 100%;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            overflow: hidden;
            margin-bottom: 12px;
            .video-area {
                height: 180px;
                position: relative;
                .img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
                .video-info {
                    width: 150px;
                    position: absolute;
                    right: 8px;
                    bottom: 8px;
                    padding: 8px 0;
                    text-align: center;
                    background: rgba(0, 0, 0, 0.25);
                    border-radius: 2px;
                    .status {
                        font-size: 13px;
                        color: #ffffff;
                        line-height: 18px;
                        margin: 0;
                    }
                    .time {
                        font-size: 11px;
                        color: #ffffff;
                        line-height: 15px;
                        margin: 0;
                        margin-top: 8px;
                    }
                }
                .video-play-btn {
                    width: 24px;
                    height: 24px;
                    position: absolute;
                    font-size: 24px;
                    color: #ffffff;
                    left: 0;
                    top: 0;
                    right: 0;
                    bottom: 0;
                    margin: auto;
                }
                .video {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            .video-title {
                font-size: 15px;
                color: rgba(0, 0, 0, 0.85);
                line-height: 21px;
                padding: 0px 8px;
                margin: 12px 0;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
            }
        }
        .news-section {
            background: #ffffff;
            border-radius: 4px;
            padding: 8px;
            display: flex;
            margin-bottom: 8px;
            &:last-child {
                margin-bottom: 12px;
            }
            .news-img {
                // width: 130px;
                // height: 73px;
                width: 30%;
                height: 64px;
                border-radius: 4px;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .news-content {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding-left: 12px;
                // padding-top: 4px;
                // padding-bottom: 4px;
                .news-title {
                    font-size: 15px;
                    line-height: 21px;
                    color: #333333;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                .news-time {
                    font-size: 11px;
                    color: #999999;
                    line-height: 15px;
                }
            }
        }
    }
    .empty-container {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        // top: 292px;
        top: 260px;
        display: flex;
        justify-content: center;
        align-items: center;
        .empty-content {
            text-align: center;
            .img {
                width: 73px;
                height: 80px;
            }
            .text {
                margin: 0;
                font-size: 12px;
                color: #8c8888;
            }
        }
    }
    .figure-loading {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

</style>
